/* eslint-disable no-param-reassign */
import { FETCH_STATUSES } from 'utils/fetchStatusUtils';

export default function deleteResourceSlice(options) {
  const { resource, repository } = options;

  return {
    initialState: {
      [resource]: {
        deleteStatus: FETCH_STATUSES.idle,
        error: null,
      },
    },
    reducers: {
      deleteResourceStart(state) {
        state[resource].deleteStatus = FETCH_STATUSES.pending;
        state[resource].error = null;
      },
      deleteResourceSuccess(state) {
        state[resource].deleteStatus = FETCH_STATUSES.fulfilled;
      },
      deleteResourceFail(
        state,
        {
          payload: { error },
        },
      ) {
        state[resource].deleteStatus = FETCH_STATUSES.failed;
        state[resource].error = error;
      },
    },
    actionCreators(restDispatch) {
      return {
        deleteResource: async (...params) => {
          restDispatch('deleteResourceStart');

          try {
            const { data } = await repository.destroy(...params);
            restDispatch('deleteResourceSuccess', data);
          } catch (error) {
            restDispatch('deleteResourceFail', { error });
            throw error;
          }
        },
      };
    },
    abstractSelector: state => {
      return {
        resource: state[resource],
      };
    },
  };
}



// WEBPACK FOOTER //
// ./src/utils/RestSlice/slices/deleteResourceSlice.js